import type { Tour } from '../tour-types';

/**
 * Settings, General: the organization's name and size, and its Slack connection (admins
 * only). The step on what gets posted needs Slack connected; before that it drops out.
 */
export const settingsGeneralTour: Tour = {
  key: 'settings.general',
  version: 1,
  routes: ['/settings/general'],
  steps: [
    {
      anchor: 'settings-general-organization',
      placement: 'bottom',
      title: 'Your organization',
      body: 'How this account is named for everyone on the team, in the account picker and on invitations. Below it are the account type and id, which cannot be changed.',
    },
    {
      // SlackNotifications renders nothing for a Member, so the step drops out for them anyway.
      anchor: 'settings-general-slack',
      placement: 'top',
      requires: 'integrations:manage',
      title: 'Slack',
      body: 'Post notifications into one Slack channel for every website in this organization. Connect a workspace, then pick the channel.',
    },
    {
      anchor: 'settings-general-slack-events',
      placement: 'top',
      requires: 'integrations:manage',
      title: 'What gets posted',
      body: 'Switch on the notifications the channel should get, from experiment progress and results to health, team and billing changes. Your own emails are set under Account.',
    },
  ],
};
